import { DocumentIcon, XMarkIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const FileIndicator = ({ file, onRemove }) => (
  <div className="border-2 border-dashed rounded-lg p-3 flex items-center gap-4">
    <div className="text-gray-600">
      <DocumentIcon className="w-6 h-6" />
    </div>
    <div className="flex-1">
      <div className="font-medium">{file.name}</div>
      <div className="text-xs text-gray-500">
        {file.type && `${file.type} | `}
        {(file.size / 1024).toFixed(1)} KB
      </div>
    </div>
    <div className="flex items-center gap-2">
      <button type="button" onClick={onRemove} className="p-2 text-gray-600 rounded-full hover:bg-gray-100">
        <XMarkIcon className="w-5 h-5" />
      </button>
    </div>
  </div>
);

FileIndicator.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default FileIndicator;
